import SearchBox from "@/common/SearchBox";
import NotifyDropDown from "./NotifyDropDown";
import { twMerge } from "tailwind-merge";

type NotifySearchAreaProps = {
    useFilter?: boolean;
    filterType?: string;
    setFilterType?: React.Dispatch<React.SetStateAction<string>>
    handleSearch?: (value: string) => void;
    dropdownOpen?: boolean;
    setDropdownOpen?: React.Dispatch<React.SetStateAction<boolean>>;
    selectedType?: string;
    setSelectedType?: React.Dispatch<React.SetStateAction<string>>;
    searchText?: string;
    setSearchText?: React.Dispatch<React.SetStateAction<string>>;
}

const NotifySearchArea = ({ useFilter = true, filterType, setFilterType, handleSearch, dropdownOpen, setDropdownOpen, selectedType, setSelectedType, searchText, setSearchText }: NotifySearchAreaProps) => {
    // const [filterType, setFilterType] = useState("전체");
    // const handleSearch = (value: string) => {   
    //     console.log(value);
    // }

    // const handleFilterType = (value: string) => {
    //     setFilterType(value);
    // }
    return (
        <>
            <SearchBox onSearch={handleSearch} searchText={searchText} setSearchText={setSearchText} />
            <div className={ twMerge("flex justify-between px-1 mt-2", useFilter ? "justify-between" : "justify-end")}>
                {useFilter &&
                    <div className="flex gap-2 text-[#999999]">
                        <button onClick={() => setFilterType?.("전체")}>
                            <span className={`${filterType === "전체" ? "text-black" : ""}`}>전체</span>
                        </button>
                        <span>|</span>
                        <button onClick={() => setFilterType?.("안읽음")}>
                            <span className={`${filterType === "안읽음" ? "text-black" : ""}`}>안읽음</span>
                        </button>
                        <span>|</span>
                        <button onClick={() => setFilterType?.("댓글없음")}>
                            <span className={`${filterType === "댓글없음" ? "text-black" : ""}`}>댓글없음</span>
                        </button>
                    </div>
                }
                <NotifyDropDown
                    dropdownOpen={dropdownOpen}
                    setDropdownOpen={setDropdownOpen}
                    selectedType={selectedType}
                    setSelectedType={setSelectedType}
                />
        </div></>
  );
};

export default NotifySearchArea;
